import React from "react"
import { Button, Col, Row } from "reactstrap";
import { useStore } from "store";
import css from "./Size.module.css"

function Size({ data }) {
    const seletedSize = useStore(state => state.size)
    const setSize = useStore(state => state.setSize)
    const reset = useStore(state => state.reset)

    function selectSize(size) {
        reset()
        setSize(size)
    }
    return (
        <>
            <Row>
                <Col>
                {data && Object.entries(data).map(([key, size]) => (
                    <Button key={key} className={css.button} outline onClick={() => selectSize(key)} active={seletedSize === key}>{size.label}</Button>
                ))}
                </Col>
            </Row>
            <Row>
                <Col>
                    <img src={process.env.PUBLIC_URL + "/img/sizes.png"} className={css.sizes} alt ="Different sizes" />
                </Col>
            </Row>
        </>
    );
}

export default Size;